import { locationIdFormat } from "@redotech/redo-ids/ids";
import { StorageLocationSchema } from "@redotech/redo-model/wms/schema/storage-location";
import * as z from "zod";

export const getStorageLocationByName = {
  name: "getStorageLocationByName" as const,
  input: z.object({ locationId: locationIdFormat.schema, name: z.string() }),
  output: z.object({ storageLocation: StorageLocationSchema.nullable() }),
};
